import { gql } from '@apollo/client'
import { PlanetFragment } from '@src/graphql/fragment/planet'

export default gql`
  query GetPlanet($planetID: String!) {
    getPlanet(planetID: $planetID) {
      ...Planet
    }
  }

  ${PlanetFragment}
`
